module.exports = __webpack_public_path__ + "static/media/idea_advisory.97088c9e.png";